/**
 * Customized to recursively check nodes for SKIP_PARSING attribute.
 */

import { getTagByKnownClass } from '@/utils/contentParsing';
import { MUI_ELEMENTS, SKIP_PARSING, SPECIAL_TAGS, TYPOGRAPHY_TAGS } from '@/utils/parseHTMLTags';
import { DOMNode, Element } from 'html-react-parser';

const shouldSkipParsing = (domNode: DOMNode | DOMNode['parent']): boolean => {
	if (!(domNode instanceof Element) || domNode.type !== 'tag') {
		return true;
	}

	const skipParsing = domNode.attribs[SKIP_PARSING];

	if (skipParsing) {
		return skipParsing === 'false' ? false : true;
	}

	const parent = domNode.parent;

	if (parent) {
		return shouldSkipParsing(parent);
	}

	return false;
};

export const parseHTMLValidate = (
	domNode: DOMNode,
	options?: {
		skipParsing?: boolean;
	}
) => {
	if (!(domNode instanceof Element) || domNode.type !== 'tag') {
		return undefined;
	}
	const { attribs, name } = domNode;

	const skipParsing =
		options?.skipParsing !== undefined ? options.skipParsing : shouldSkipParsing(domNode);

	if (skipParsing) {
		return undefined;
	}

	const knownComp = getTagByKnownClass(attribs);
	const NormalComponent =
		MUI_ELEMENTS[attribs.element] ||
		MUI_ELEMENTS[knownComp] ||
		TYPOGRAPHY_TAGS[knownComp] ||
		TYPOGRAPHY_TAGS[name];
	const SpecialComponent = !NormalComponent && SPECIAL_TAGS[name];
	const Component = NormalComponent || SpecialComponent;
	return { SpecialComponent, Component };
};
